import React from "react";
import Button from "@material-ui/core/Button";
import Dialog from "@material-ui/core/Dialog";
import TextField from "@material-ui/core/TextField";
import MenuItem from "@material-ui/core/MenuItem";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import { Row, Col } from "react-flexbox-grid";
import "cropperjs/dist/cropper.css";

import "./styles.css";

class ArticuloNuevoModal extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      cleanSuper: true,
      cleanRub: true,
    };
  }

  handleOnVolver = () => {
    this.setState({
      cleanSuper: true,
      cleanRub: true,
    });
    this.props.handleCloseModal();
  };

  handleCleanSup = (e) => {
    this.setState({
      cleanSuper: false,
    });
    this.props.handleIdSuperRubro(e);
  };

  handleCleanRub = (e) => {
    this.setState({
      cleanRub: false,
    });
    this.props.handleIdRubro(e);
  };

  render() {
    return (
      <Dialog
        open={this.props.open}
        onClose={this.handleClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        className="busquedaAvanzada"
        fullWidth={true}
        maxWidth={"sm"}
      >
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            {/* TITLE */}
            <Row>
              <Col xs={12} className="title">
                <div>Elegir Rubro</div>
              </Col>
            </Row>

            {/* SEPARADOR */}
            <Row>
              <Col xs={12} className="separador"></Col>
            </Row>

            {/* COMBO SUPER */}
            <Row>
              <Col xs={12} className="contenido">
                <TextField
                  id="textFieldSuperRubro"
                  className="filterInput"
                  style={{ textAlign: "left" }}
                  fullWidth
                  select
                  error={this.props.superRubroValidoModal === false ? true : false}
                  helperText={
                    this.props.superRubroValidoModal === false
                      ? "Por favor seleccione un superRubro válido."
                      : ""
                  }
                  label="Superrubro"
                  value={
                    this.state.cleanSuper === true && this.props.superRubroUnico === false
                      ? ""
                      : this.props.filtros.idSuperRubro
                  }
                  name="idSuperRubro"
                  onChange={this.handleCleanSup}
                >
                  {this.props.superRubros !== undefined
                    ? this.props.superRubros.map((e) => (
                        <MenuItem
                          key={e.idSuperRubro}
                          value={e.idSuperRubro}
                          id={`menuItemRubro-${e.idSuperRubro}`}
                        >
                          {e.nombre}
                        </MenuItem>
                      ))
                    : ""}
                </TextField>
              </Col>
            </Row>

            {/* COMBO RUBRO */}
            <Row>
              <Col xs={12} className="contenido">
                <TextField
                  id="textFieldRubro"
                  className="filterInput"
                  style={{ textAlign: "left" }}
                  fullWidth
                  select
                  error={this.props.rubroValidoModal === false ? true : false}
                  helperText={
                    this.props.rubroValidoModal === false
                      ? "Por favor seleccione un rubro válido."
                      : ""
                  }
                  label="Rubro"
                  value={
                    this.state.cleanRub === true && this.props.rubroUnico === false
                      ? ""
                      : this.props.filtros.idRubro
                  }
                  name="idRubro"
                  onChange={this.handleCleanRub}
                >
                  {this.props.rubros !== undefined
                    ? this.props.rubros.map((e) => {
                        return (
                          e.idSuperRubro === this.props.filtros.idSuperRubro && (
                            <MenuItem
                              key={e.idRubro}
                              value={e.idRubro}
                              id={`menuItemRubro-${e.idRubro}`}
                            >
                              {e.nombre}
                            </MenuItem>
                          )
                        );
                      })
                    : ""}
                </TextField>
              </Col>
            </Row>
          </DialogContentText>
        </DialogContent>

        <DialogActions className="" id="ecommerce">
          <Button onClick={this.handleOnVolver} className="btnSecundario">
            VOLVER
          </Button>
          <Button
            onClick={() =>
              this.props.handleCreateArticuloFromModal(
                this.props.filtros.idRubro,
                this.props.filtros.idSuperRubro
              )
            }
            className="btnPrincipal"
          >
            CONTINUAR
          </Button>
        </DialogActions>
      </Dialog>
    );
  }
}

export default ArticuloNuevoModal;
